import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast,
  Flex,
} from '@chakra-ui/react';
import React from 'react';

import { InvalidateItemModalProps } from 'types/plaid';

import {
  GetAllPlaidInstitutionAccountsDocumentGQLType,
  GetPlaidLinkTokenDocumentGQLType,
  useInvalidatePlaidItemMutation,
} from '../requests/plaid.gql.generated';
import {
  GetBankAccountsByCreditFacilityIdDocumentGQLType,
  GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType,
} from '~/packages/bankAccounts/requests/bankAccounts.gql.generated';
import { successToastConfig } from '~/packages/common-frontend/constants';

export const InvalidateItemModal = ({
  isOpen,
  onClose,
  name,
  plaidItemId,
}: InvalidateItemModalProps) => {
  const toast = useToast();

  const [
    disconnectPlaidItem,
    { loading: disconnectPlaidItemLoading },
  ] = useInvalidatePlaidItemMutation({
    refetchQueries: [
      GetPlaidLinkTokenDocumentGQLType,
      GetAllPlaidInstitutionAccountsDocumentGQLType,
      GetBankAccountsByCreditFacilityIdDocumentGQLType,
      GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType,
    ],
  });

  const invalidateItem = async () => {
    await disconnectPlaidItem({ variables: { plaidItemId } });
    toast({
      ...successToastConfig,
      title: `${name} integration successfully removed`,
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Removal</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to remove your {name} integration?
        </ModalBody>
        <ModalFooter>
          <Flex gap="0.5rem">
            <Button variant="v2-ghost" colorScheme="gray" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              colorScheme="red"
              isLoading={disconnectPlaidItemLoading}
              onClick={invalidateItem}
            >
              Remove
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
